// @flow
/* eslint-disable import/prefer-default-export */
// $FlowFixMe
import type { UseQueryResult } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";
import { QUERIES } from "@/enums/queries";
import type { UpdateResponseQueue } from "types/response_queue";

import { updateResponseQueue } from "./services/mutateResponseQueue";
import { invalidateLoadResponseQueue } from "./useLoadResponseQueue";

type Props = {
  updateResponseQueue: (data: UpdateResponseQueue) => Promise<void>,
  isLoading: boolean,
} & UseQueryResult<{ message: string }, Error>;

export const useUpdateResponseQueue = (options: any = {}): Props => {
  const mutation = useMutation({
    mutationKey: [QUERIES.RESPONSE_QUEUE.UPDATE],
    mutationFn: async (data: UpdateResponseQueue) =>
      await updateResponseQueue(data),
    onSuccess: () => {
      invalidateLoadResponseQueue();
    },
    ...options,
  });

  const updateResponseQueueReq = async (data: UpdateResponseQueue) => {
    return mutation.mutateAsync(data);
  };

  return {
    updateResponseQueue: updateResponseQueueReq,
    ...mutation,
  };
};
